(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-rr-section]');

  sections.forEach(function (section) {
    var carousel = section.querySelector('.rr-carousel');
    var wrap = section.querySelector('.rr-carousel-wrap');
    var prevBtn = section.querySelector('.rr-arrow--prev');
    var nextBtn = section.querySelector('.rr-arrow--next');

    if (!carousel) return;

    var cardWidth = 340; // card width + gap

    // Fade gradient edge detection
    function updateFades() {
      if (!wrap) return;
      var scrollLeft = carousel.scrollLeft;
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;

      wrap.classList.toggle('is-at-start', scrollLeft <= 2);
      wrap.classList.toggle('is-at-end', scrollLeft >= maxScroll - 2);
    }

    carousel.addEventListener('scroll', updateFades, { passive: true });
    updateFades();
    var autoAdvanceInterval = null;

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
      });
    }

    // Auto-advance every 5s
    function startAutoAdvance() {
      autoAdvanceInterval = setInterval(function () {
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (carousel.scrollLeft >= maxScroll - 10) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
        }
      }, 5000);
    }

    function stopAutoAdvance() {
      clearInterval(autoAdvanceInterval);
    }

    startAutoAdvance();

    // Pause on hover/focus
    carousel.addEventListener('mouseenter', stopAutoAdvance);
    carousel.addEventListener('focusin', stopAutoAdvance);
    carousel.addEventListener('mouseleave', startAutoAdvance);
    carousel.addEventListener('focusout', startAutoAdvance);
  });
})();
